<template>
  <table :data-comNum="com.comNum">
    <tr v-for="cell in TList" :key="cell.num">
      <td
        class="Lpoint"
        v-on="{
          mouseenter: focusPo,
          mouseleave: unfocusPo,
          click: lineToPo,
        }"
        :data-cellNum="cell.cellNum"
      >
        <img src="../../img/pointF.png" v-if="cell.LfocusPo" />
        <img src="../../img/point.png" v-else />
      </td>
      <td>
        <textarea
          v-if="cell.isWriting"
          :data-comNum="com.comNum"
          :data-cellNum="cell.cellNum"
          v-model="cell.text"
          v-bind:style="{ width: com.width }"
          v-on="{ mousedown: nonEvent, blur: writeEnd }"
        ></textarea>

        <textarea
          class="titleEditor"
          :data-cellNum="cell.cellNum"
          v-if="cell.isWriting"
          v-model="cell.title"
          v-on="{ blur: writeEnd }"
        ></textarea>

        <p
          v-else
          :title="cell.title"
          class="designText"
          :data-cellNum="cell.cellNum"
          :data-comNum="com.id"
          v-on="{ mousedown: nonEvent, click: writeMode }"
        >
          {{ cell.text }}
        </p>
      </td>
      <td
        class="Rpoint"
        v-on="{
          mouseenter: focusPo,
          mouseleave: unfocusPo,
          click: lineToPo,
        }"
        :data-cellNum="cell.cellNum"
      >
        <img src="../../img/pointF.png" v-if="cell.RfocusPo" />
        <img src="../../img/point.png" v-else />
      </td>
    </tr>
  </table>
  <input type="button" value="1行追加" class="addRow" v-on:click="addRow" />
  <input type="button" value="1行削除" class="subRow" v-on:click="subRow" />
</template>

<script>
import ArrowCam from "./arrowCanvas.js";
import NodePosi from "./nodePosi.js";
import KeySearch from "./keySearch.js";

export default {
  name: "ComConstruct",
  props: {
    com: { type: Object },
    comNum: { type: Number },
    texts: { type: Array },
  },
  data() {
    return {
      TList: [],
    };
  },
  mounted() {
    for (let i = 0; i < this.texts.length; i++) {
      this.TList.push({
        cellNum: i,
        isWriting: false,
        RfocusPo: false,
        LfocusPo: false,
        text: this.texts[i].text,
        title: this.texts[i].title,
        Rposi: [],
        Lposi: [],
      });
    }
    this.RowSize = this.ComHeight = this.com.style.height;
    this.histTmp = {};
    this.syncPoPosi(this.comNum);
  },
  methods: {
    syncPoPosi: function (comNum) {
      this.$nextTick(function () {
        //   console.log(comNum);
        const table = document.getElementsByTagName("table");
        console.log(table[0].getElementsByClassName("Rpoint")[0]);
        for (let i = 0; i < table.length; i++) {
          if (table[i].dataset.comnum == comNum) {
            var Node = table[i];
            break;
          }
        }
        this.rowHeightCheck(Node);
        //console.log(Node.getElementsByClassName("Rpoint")[0]);
        const RP = Node.getElementsByClassName("Rpoint");
        const LP = Node.getElementsByClassName("Lpoint");
        //  console.log(document.getElementsByClassName("Rpoint")[0]);
        const canvas = document.getElementById("canvas");
        for (let i = 0; i < RP.length; i++) {
          this.TList[i].Lposi = new NodePosi(LP[i], canvas);
          this.TList[i].Rposi = new NodePosi(RP[i], canvas);
          //          console.log(this.TList[i].Lposi, this.TList[i].Rposi);
        }
        this.$parent.drawLines();
      });
    },
    rowHeightCheck: function (node) {
      if (parseInt(this.com.style.width) < node.clientWidth - 40) {
        this.com.style.width = node.clientWidth + "px";
      }
      if (parseInt(this.com.style.height) < node.clientHeight) {
        this.com.style.height = node.clientHeight + "px";
      }
      //      console.log("minimam", this.com.style.width, node.clientWidth);
    },
    addRow: function () {
      this.TList.push({
        cellNum: this.TList.length,
        isWriting: false,
        RfocusPo: false,
        LfocusPo: false,
        text: "",
        title: "",
        Rposi: [],
        Lposi: [],
      });
      this.syncPoPosi(this.comNum);
    },
    subRow: function () {
      this.TList.pop();
    },
    writeMode: function (e) {
      /* dataset はキャメル文字が小文字にされる*/
      const cellNum = e.target.dataset.cellnum;
      this.TList[cellNum].isWriting = !this.TList[cellNum].isWriting;
      this.histTmp = [this.TList[cellNum].text, this.TList[cellNum].title];

      this.$nextTick(() =>
        document.getElementsByTagName("textarea")[0].focus()
      );
    },
    writeEnd: function (e) {
      const cellNum = e.target.dataset.cellnum;
      //console.log(e.relatedTarget.className);
      if (!e.relatedTarget || e.relatedTarget.className != "titleEditor")
        this.TList[cellNum].isWriting = !this.TList[cellNum].isWriting;
      console.log(e.target);
      console.log("comNum" + this.com.comNum);
      //console.log(this.$parent, this.$parent.undoStack);
      this.$parent.undoStack.push({
        type: "write",
        BfTar: this.histTmp,
        AfTar: cellNum,
        comNum: this.com.comNum,
      });
    },
    nonEvent: function (e) {
      e.stopPropagation();
    },
    focusPo: function (e) {
      const cellNum = e.target.dataset.cellnum;
      //  console.log(cellNum, this.TList[cellNum]);
      if (e.target.className == "Rpoint") this.TList[cellNum].RfocusPo = true;
      else this.TList[cellNum].LfocusPo = true;
    },
    unfocusPo: function (e) {
      const cellNum = e.target.dataset.cellnum;
      // console.log(cellNum, this.TList[cellNum]);
      this.TList[cellNum].RfocusPo = false;
      this.TList[cellNum].LfocusPo = false;
    },
    lineToPo: function (e) {
      if (e.target.tagName == "IMG") {
        // console.log(e.target.parentNode);
        var cellNum = e.target.parentNode.dataset.cellnum;
      } else {
        var cellNum = e.target.dataset.cellnum;
      }
      //search
      const targetPo = KeySearch(cellNum, this.TList, "cellNum");
      //console.log("lineToPo", targetPo);
      //console.log(this.$parent.pointTmpPosi);
      if (this.$parent.pointTmpPosi.comNum == -1) {
        console.log("moveto", this.$parent.pointTmpPosi);
        this.$parent.pointTmpPosi = { comNum: this.comNum, cellNum: cellNum };
        console.log("moveto", this.$parent.pointTmpPosi);
      } else {
        //プロパティはリテラルコピーされる　参照ではない
        const lineData = {
          isfocus: false,
          type: "drawLine",
          class: this.$parent.mode,
          moveTo: this.$parent.pointTmpPosi,
          lineTo: {
            comNum: this.comNum,
            cellNum: cellNum,
          },
        };
        this.$parent.lineList.push(lineData);
        this.$parent.drawLines();
        this.$parent.pointTmpPosi = { comNum: -1 };
        this.$parent.undoStack.push(lineData);
      }
    },
    undo: function (undo) {
      //const undo = this.$parent.undoStack.pop();
      console.log(undo);
      this.$parent.redoStack.push({
        type: "write",
        BfTar: [this.TList[undo.AfTar].text, this.TList[undo.AfTar].title],
        AfTar: undo.AfTar,
        comNum: undo.comNum,
      });
      this.TList[undo.AfTar].text = undo.BfTar[0];
      this.TList[undo.AfTar].title = undo.BfTar[1];
    },
    redo: function (redo) {
      //const redo = this.$parent.redoStack.pop();
      this.$parent.undoStack.push({
        type: "write",
        BfTar: [this.TList[redo.AfTar].text, this.TList[redo.AfTar].title],
        AfTar: redo.AfTar,
        comNum: redo.comNum,
      });
      this.TList[redo.AfTar].text = redo.BfTar[0];
      this.TList[redo.AfTar].title = redo.BfTar[1];
    },
  },
};
</script>

<style scoped lang="scss">
table {
  width: calc(100% + 30px);
  height: 90%;
  margin: 15px -15px 0px;
  position: relative;
  top: -50px;
  z-index: 2;
}
.addRow,
.subRow {
  display: block;
  width: 100%;
  background-color: #dd9;
  position: relative;
  top: -50px;
}
.subRow {
  background-color: #d9d;
}
tr,
td {
  //width: 100%;
  height: 13pt;
  //background-color: #ccc;
  white-space: wrap;
  textarea {
    width: 99%;
    height: 99%;
    background-color: #dda;
    white-space: no-wrap;
  }
  .titleEditor {
    display: inline-block;
  }
  .designText {
    cursor: text;
    white-space: pre;
    width: 100%;
    height: 100%;
    background-color: #aaf;
  }
  .Rpoint,
  .Lpoint {
    width: 15px;
    opacity: 0.4;
  }
  img {
    width: 15px;
  }
}
</style>
